import type { InferSelectModel } from 'drizzle-orm';
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { instagramAccounts } from './instagram-accounts';
import { photos } from './photos';

/**
 * Últimos posts de cada conta do Instagram, mostrados no site ("Siga a gente"). O robô de hora em
 * hora reescreve as linhas da conta — 3 por conta. A imagem não é duplicada: aponta pra foto do
 * álbum "Instagram · @conta" da galeria. Tabela técnica (delete físico).
 */
export const instagramPosts = pgTable(
  'instagram_posts',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    accountId: uuid('account_id')
      .references(() => instagramAccounts.id, { onDelete: 'cascade' })
      .notNull(),
    /** 0 = mais recente. */
    position: integer('position').notNull(),
    /** ID da mídia na API do Instagram. */
    mediaId: text('media_id').notNull(),
    mediaType: text('media_type').notNull(),
    permalink: text('permalink').notNull(),
    caption: text('caption'),
    postedAt: timestamp('posted_at').notNull(),
    photoId: uuid('photo_id')
      .references(() => photos.id)
      .notNull(),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
  },
  (t) => [index('instagram_posts_account_id_idx').on(t.accountId)],
);

export type InstagramPostRow = InferSelectModel<typeof instagramPosts>;
